export default "__VITE_ASSET__Dnuh3HhG__"